import {EnumCorridorColor} from '../enum/enum-corridor-color';

export class CorridorLevelBlock {
    public p?: string;
    public r?: string;
    public color?: EnumCorridorColor;
    public matched: boolean = false;
    public isBelowBlack: boolean = false;
    public topStyle?: string;

    constructor(p: string, r: string, color: EnumCorridorColor, matched: boolean, isBelowBlack: boolean, topStyle: string) {
        this.p = p;
        this.r = r;
        this.color = color;
        this.matched = matched;
        this.isBelowBlack = isBelowBlack;
        this.topStyle = topStyle;
    }

}
